module.exports = __webpack_public_path__ + "img/santamarta.4958cb52.jpg";